// NOTE: 這些常數定義在 Matomo 網頁裡的 Administration -> Intranet Websites -> Custom Dimensions，需要增加後，畫面才會顯示出來
export const LOGIN_ID_DIMENSION = 1;
export const POST_ID_DIMENSION = 2;
export const PUBNUB_ID_DIMENSION = 3;
/** 記錄 17shop 頁面帶的 stream id */
export const STREAM_ID_DIMENSION = 4;
/** 紀錄 tracker 的鏈結來源，其對應的值有 'cms' | 'liveweb' | 'oneSevenShop' | 'marketplace' */
export const SOURCE_ID_DIMENSION = 5;
